@import "~swiper/swiper.scss";
@import "~swiper/modules/navigation/navigation.scss";
@import "~swiper/modules/pagination/pagination.scss";


$navigation-button-width: 44px;
$navigation-button-height: 44px;

:host {
  display: block;
}

.swiper-wrapper {
  height: auto;
}

.swiper-slide {
  height: auto;
}

.swiper-button-next, .swiper-button-prev {
  top: calc(50% - (#{$navigation-button-height} / 2));
  width: $navigation-button-width;
  height: $navigation-button-height;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  padding: 0;
  outline: none !important;
  &:focus, &:active {
    svg {
      opacity: 1;
    }
  }
  @media only screen and (max-width : 799.98px) {
    display: none;
  }

  &.swiper-button-disabled {
    svg {
      opacity: 0;
    }
  }

  svg {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    opacity: 0;
    background: #101010;
    transition: opacity .2s ease-in-out;

    path {
      fill: #FFFFFF;
    }
  }

  &::after {
    display: none;
  }

  .swiper:hover & {
    svg {
      opacity: 0.5;
    }
  }

  .swiper:hover &:hover,
  .swiper:hover &:active,
  .swiper:hover &:focus {
    svg {
      opacity: 1;
    }
  }
}

.swiper-button-prev {
  svg {
    transform: rotateY(180deg);
  }
}

// fix origin swiper mobile pagination position
.swiper-pagination-bullets {
  display: none;
  @media only screen and (max-width : 799.98px) {
    margin: 10px auto 10px auto;
    display: block;
    &.swiper-pagination-horizontal {
      left: 0;
      transform: none;
      position: relative;
      bottom: 0;
    }
    .swiper-pagination-bullet {
      display: inline-block;
      background: black;
      opacity: .2;

      &.swiper-pagination-bullet-active {
        opacity: 1;
        background: black;
      }
    }
  }
}

.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic, 
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  @media only screen and (max-width : 799.98px) {
    left: 0;
    transform: none;
  }
}